import React from 'react'
import Svg, { G, Path, Rect, SvgProps } from 'react-native-svg'

const GasTankIcon: React.FC<SvgProps> = ({
  width = 32,
  height = 32,
  color = '#ae60ff',
  ...rest
}) => (
  <Svg width={width} height={height} viewBox="0 0 32 32" {...rest}>
    <Rect width={width} height={height} fill="none" rx="6" />
    <G fill={color}>
      <Path d="M7.628 26a.9.9 0 0 1-.9-.9v-.581a.9.9 0 0 1 .9-.9H18.74a.9.9 0 0 1 .9.9v.581a.9.9 0 0 1-.9.9Zm.1-3.414V7.256a1.251 1.251 0 0 1 .374-.887A1.251 1.251 0 0 1 8.989 6h8.444a1.255 1.255 0 0 1 1.157.767 1.252 1.252 0 0 1 .1.489c-.025 9.458.058 10.308 0 15.33Zm2.331-13.214v3.569a.6.6 0 0 0 .6.6h4.977a.6.6 0 0 0 .6-.6V9.372a.6.6 0 0 0-.6-.6h-4.974a.6.6 0 0 0-.603.6Z" />
      <Path d="M18.69 17.272h.34a1.882 1.882 0 0 1 1.329.552 1.86 1.86 0 0 1 .552 1.329v1.876a.99.99 0 0 0 1.979-.008v-4.282h-1.07a.445.445 0 0 1-.446-.446v-4.48a.45.45 0 0 1 .255-.4l2.749-1.293v-1l-2.763-1.424a.446.446 0 0 1 .406-.793l3.009 1.549a.443.443 0 0 1 .241.395v7.45a.447.447 0 0 1-.446.446h-.947v4.28a1.966 1.966 0 0 1-.579 1.4 1.981 1.981 0 0 1-3.221-.632 1.993 1.993 0 0 1-.151-.622v-1.918a.992.992 0 0 0-.989-.989h-.248Z" />
    </G>
  </Svg>
)

export default GasTankIcon
